import type { UIStore } from '~/modules/ui/index.store';
import type { GifEmbedAssetState } from './index.types';
import {
  DEFAULT_GIF_EMBED_ASSET,
  EMPTY_GIF_ID_ASSET,
} from './index.slice';

export function selectGifEmbedAsset(
  state: UIStore,
  trimmedId: string
): GifEmbedAssetState {
  if (!trimmedId) {
    return EMPTY_GIF_ID_ASSET;
  }

  return state.gifEmbedAssetsById[trimmedId] ?? DEFAULT_GIF_EMBED_ASSET;
}
